import { Client } from "../../../client";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { proccessErrorMessage } from "../../../helper/proccessErrorMessage";
import { API_OPEN_INVESTMENT } from "../../../config/api";
import mixpanel from "mixpanel-browser";

export const getOpenInvestments = createAsyncThunk(
  "getOpenInvestments/get",
  async ({ cb, failed, currency }, { rejectWithValue }) => {
    try {
      const { data } = await Client({
        method: "GET",
        path: `${API_OPEN_INVESTMENT}?currency=${currency}&status=1&show_mudarabah=1`,
      });

      cb(data?.data);
      return data?.data;
    } catch (error) {
      const msg = proccessErrorMessage(error);
      // mixpanel.track("Error", {
      //   type: "portfolio",
      //   subtype: "get-my-portfolio",
      //   message: msg,
      // });
      failed();
      // toast.error(msg);
      throw error;
    }
  }
);
